import { PortfolioEnterpriseProductDetails } from '@mews-commander/data-access';

export interface LocalizedProductDetails {
    [k: string]: {
        externalName?: string;
        description?: string;
        name?: string;
        shortName?: string;
    };
}

export const transformLocalizedProductDetails = (data: PortfolioEnterpriseProductDetails): LocalizedProductDetails => {
    const { externalNames, descriptions, names, shortNames } = data;

    const uniqueLanguageKeys = new Set([
        ...Object.keys(names ?? {}),
        ...Object.keys(externalNames ?? {}),
        ...Object.keys(descriptions ?? {}),
        ...Object.keys(shortNames ?? {}),
    ]);

    return Array.from(uniqueLanguageKeys).reduce<LocalizedProductDetails>((acc, lang) => {
        acc[lang] = {
            ...(externalNames?.[lang] && { externalName: externalNames[lang] }),
            ...(descriptions?.[lang] && { description: descriptions[lang] }),
            ...(shortNames?.[lang] && { shortName: shortNames[lang] }),
            ...(names?.[lang] && { name: names[lang] }),
        };
        return acc;
    }, {});
};
